import { ToastPassThroughOptions } from 'primereact/toast'

export const toastConfig: ToastPassThroughOptions = {
  root: { className: 'mk-toast' },
  content: { className: 'mk-toast__content' },
  icon: { className: 'mk-toast__icon' },
  text: { className: 'mk-toast__text' },
  summary: { className: 'mk-toast__summary' },
  detail: { className: 'mk-toast__detail' },
  closeButton: { className: 'mk-toast__close' },
}
